/**
 * TanStack Query hooks for `creative-max-50mb-upload`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	creativeMax50mbUploadQueryKeys,
	type CreateCreativeMax50mbUploadBody,
	type ListCreativeMax50mbUploadResponse,
	type CreativeMax50mbUploadRow,
} from "./api";

export function useCreativeMax50mbUploadList(): UseQueryResult<ListCreativeMax50mbUploadResponse, Error> {
	return useQuery({
		queryKey: creativeMax50mbUploadQueryKeys.list(),
		queryFn: list,
	});
}

export function useCreativeMax50mbUploadCreate(): UseMutationResult<CreativeMax50mbUploadRow, Error, CreateCreativeMax50mbUploadBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeMax50mbUploadQueryKeys.all });
		},
	});
}

export function useCreativeMax50mbUploadDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeMax50mbUploadQueryKeys.all });
		},
	});
}
